import { useIntercom } from "react-use-intercom";
import { useEffect } from "react";

import { useGetAssignedCompanies, useGetCurrentCompanyInfo } from "@api";
import { useUserStore } from "@store/user";

export const useBootIntercom: () => void = () => {
  const { user } = useUserStore();
  const { shutdown, boot } = useIntercom();
  const { currentCompanyInfo } = useGetCurrentCompanyInfo(user);
  const { assignedCompanies } = useGetAssignedCompanies();

  useEffect(() => {
    if (user && currentCompanyInfo && assignedCompanies) {
      boot({
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        userId: user.id,
        userHash: user.intercomHash,
        company: {
          companyId: currentCompanyInfo.id,
          name: currentCompanyInfo.name,
        },
        companies: assignedCompanies.map(({ id, name }) => ({
          companyId: id,
          name,
        })),
        customAttributes: {
          platformRole: user.role,
        },
      });
    } else {
      shutdown();
      boot();
    }
  }, [user, currentCompanyInfo, assignedCompanies]);
};
